import React from 'react'
import { MapPin, ExternalLink, Building2 } from 'lucide-react'
import type { OrganizationDetails } from '@tatatemplate/shared-lib'

interface LocationCardProps {
  desa: OrganizationDetails
  showHeader?: boolean
}

export function LocationCard({ desa, showHeader = true }: LocationCardProps) {
  if (!desa.latitude || !desa.longitude) {
    return null
  }

  const googleMapsUrl = `https://www.google.com/maps?q=${desa.latitude},${desa.longitude}`
  // Using Google Maps with simple embed URL (no API key required)
  const googleMapEmbedUrl = `https://maps.google.com/maps?q=${desa.latitude},${desa.longitude}&t=&z=15&ie=UTF8&iwloc=&output=embed`

  return (
    <div className={`w-full ${showHeader ? 'bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden' : ''}`}>
      <div className={`${showHeader ? 'p-8 ' : ''}space-y-6`}>
        {showHeader && (
          <div className="mb-6">
            <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-3">
              <div className="w-2 h-6 bg-blue-600 rounded-full"></div>
              <MapPin className="w-6 h-6 text-blue-600" />
              Peta dan Navigasi
            </h3>
            <p className="text-gray-600">Lokasi dan petunjuk arah menuju kantor desa</p>
          </div>
        )}

        {/* Google Maps Embed - Increased height to h-[500px] */}
        <div className="relative w-full h-[500px] rounded-xl overflow-hidden border border-gray-200 shadow-md">
          <iframe
            src={googleMapEmbedUrl}
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title={`Lokasi ${desa.name}`}
          />
        </div>

        {/* Informasi Koordinat dan Navigasi */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 p-6 bg-gradient-to-r from-blue-50 to-blue-100 rounded-xl border border-blue-200 shadow-sm">
          <div>
            <p className="font-semibold text-blue-900 mb-1 flex items-center gap-2">
              <MapPin className="w-4 h-4" />
              Koordinat GPS
            </p>
            <p className="text-blue-700 font-medium">
              {desa.latitude}, {desa.longitude}
            </p>
          </div>
          <a
            href={googleMapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all duration-200 font-medium shadow-sm hover:shadow-md transform hover:-translate-y-0.5"
          >
            <ExternalLink className="w-5 h-5" />
            Navigasi Google Maps
          </a>
        </div>

        {/* Alamat Lengkap */}
        {desa.address && (
          <div className="p-6 bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl border border-green-200 shadow-sm">
            <p className="font-semibold text-green-900 mb-2 flex items-center gap-2">
              <Building2 className="w-4 h-4" />
              Alamat Lengkap
            </p>
            <p className="text-green-700 leading-relaxed">{desa.address}</p>
          </div>
        )}
      </div>
    </div>
  )
}